<template>
    <div class="mypage_common connect">
        <div class="common_head">
            <h5>SNS 연결설정</h5>
            <p>SNS계정과 연동하여 간편하게 로그인 하실 수 있습니다.</p>
        </div>
        <div class="common_body">
            <div class="tbl_wrap">
                <table class="connect">
                    <tbody>
                        <tr>
                            <th>
                                <div class="login_badge naver">
                                    <i class="ico_naver"></i>네이버 로그인
                                </div>
                            </th>
                            <td>
                                <div class="wrapper" v-if="connectInfo.isNaver">
                                    <p>{{ connectInfo.naverConnectDate }} 연결</p>
                                </div>
                                <div class="wrapper" v-else>
                                    <p></p>
                                    <a class="btn_connect" @click="connectNaver">연결하기</a>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <div class="login_badge kakao">
                                    <i class="ico_kakao"></i>카카오 로그인
                                </div>
                            </th>
                            <td>
                                <div class="wrapper" v-if="connectInfo.isKakao">
                                    <p>{{ connectInfo.kakaoConnectDate }} 연결</p>
                                </div>
                                <div class="wrapper" v-else>
                                    <p></p>
                                    <a class="btn_connect" @click="connectKakao">연결하기</a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ul class="connect_txt">
                <li>
                    <span>·</span> 네이버, 페이스북, 카카오 계정과 연동하여 간편하게 로그인 할 수 있는 기능을 설정/해제 하실 수 있습니다.
                </li>
                <li>
                    <span>·</span> 로그인 연결 해제는 단순히 SNS 로그인 기능만을 해제 하는 것이며, 회원탈퇴가 되는 것은 아닙니다.
                </li>
                <li>
                    <span>·</span> 블러썸로고스의 계정은 삭제 되지 않으며, 기존 아이디(이메일), 패스워드로 로그인이 가능합니다.
                </li>
                <li>
                    <span>·</span>  회원탈퇴는 정보관리&gt;회원탈퇴 메뉴를 통해 가능합니다.
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

const accountModule = 'accountModule'

export default {
  data () {
    return {
      connectInfo: {}
    }
  },

  methods: {
    ...mapActions(accountModule, [
        'requestCheckConnect',
        'requestKakaoOauthConnectRedirectUrl',
        'requestNaverOauthConnectRedirectUrl'
    ]),

    async connectKakao() {
      await this.requestKakaoOauthConnectRedirectUrl()
    },

    async connectNaver() {
        await this.requestNaverOauthConnectRedirectUrl()
    }
  },

  async mounted() {
    this.connectInfo = await this.requestCheckConnect()
  }
}
</script>